export default "__VITE_ASSET__BZnijV$w__"